import '@adornis/chemistry/elements/components/x-flex';
import '@adornis/chemistry/elements/components/x-grid';
import '@adornis/chemistry/elements/components/x-icon';
import '@adornis/chemistry/elements/components/x-link';
import { createComponentsFromChemistryBase } from '@adornis/chemistry/elements/x-components';
import '@adornis/fonts/fontSrc/lato';
import '@adornis/fonts/fontSrc/maven-pro';
import '@adornis/fonts/fonts';
import '../components/fps-checkbox';
import '../components/fps-fonts';
import './assets';
import './theme';

createComponentsFromChemistryBase('x-flex', 'x-link', 'x-icon', 'x-grid');
